import { FC, useState } from 'react';

import DealTabsForInvites from './DealTabsForInvites';
import InviteLinks from './InviteLinks';
import InviteNetwork from './InviteNetwork';
import ManageInvites from './ManageInvites';

const InviteUsersToDeal: FC = () => {
  const [activeTab, setActiveTab] = useState('manage-invites');

  function renderContent() {
    switch (activeTab) {
      case 'manage-invites':
        return <ManageInvites />;
      case 'invite-network':
        return <InviteNetwork />;
      case 'invite-links':
        return <InviteLinks />;
      default:
        return null;
    }
  }

  return (
    <div className="w-full">
      <div className="relative mb-6">
        <DealTabsForInvites activeTab={activeTab} onSelect={setActiveTab} />
      </div>
      <div>{renderContent()}</div>
    </div>
  );
};

export default InviteUsersToDeal;
